import { nip19 } from 'nostr-tools';
import { useParams, Navigate } from 'react-router-dom';
import NotFound from './NotFound';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type } = decoded;

  switch (type) {
    case 'npub':
      // Redirect npub to the merchant page
      return <Navigate to={`/merchant/${identifier}`} replace />;

    case 'nprofile': {
      // Encode the pubkey as npub and redirect to merchant page
      const npub = nip19.npubEncode(decoded.data.pubkey);
      return <Navigate to={`/merchant/${npub}`} replace />;
    }

    case 'note':
    case 'nevent':
    case 'naddr':
      // Not handled in this app
      return <NotFound />;

    default:
      return <NotFound />;
  }
}
